<template>
  <!-- 添加员工、编辑员工、编辑部门信息公用 -->
  <el-dialog class="dialog-add-staff" :title="titleMap" @close="cancel" :visible.sync="dialogVisible" width="800px">
    <!-- 添加员工、编辑员工 start -->
    <div v-if="bussinessType === 'staff'">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-row :gutter="20">
          <template v-if="pageType === 'join'">
            <el-col :span="24">
              <el-form-item :label="'用户名 :'">{{ form.userName }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="注册手机号 :">{{ form.phone }}</el-form-item>
            </el-col>
          </template>

          <el-col :span="24">
            <el-form-item :label="'姓名 :'" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <template v-if="pageType !== 'join'">
            <el-col :span="24">
              <el-form-item label="注册手机号 :" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入"
                  :disabled="pageType === 'edit' || pageType === 'detail'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="pageType === 'add'">
              <el-form-item label="登录密码 :" prop="passwd">
                <el-input type="password" v-model="form.passwd" placeholder="请输入6至20位登录密码"></el-input>
              </el-form-item>
            </el-col>
          </template>

          <el-col :span="24">
            <el-form-item label="身份证号 :" prop="idcard">
              <el-input v-model="form.idcard" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="工号 :" prop="employeeNum">
              <el-input v-model="form.employeeNum" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="员工类型 :" prop="typeId">
              <el-select v-model="form.typeId" placeholder="请选择" :disabled="pageType === 'detail'">
                <el-option v-for="item in staffTypeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="所属部门 :" prop="deptId">
              <el-select v-model="form.deptId" filterable placeholder="请选择" :disabled="pageType === 'detail'">
                <el-option v-for="item in departmentArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="所属党支部 :" prop="partyDept">
              <el-select v-model="form.partyDept" filterable placeholder="请选择" :disabled="pageType === 'detail'">
                <el-option v-for="item in partyDeptArr" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="党部角色 :" prop="partJob">
              <el-select v-model="partJob" multiple filterable placeholder="请选择" :disabled="pageType === 'detail'">
                <el-option v-for="item in partyJobArr" :key="item.label" :label="item.label"
                  :value="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="职位 :" prop="jobId">
              <el-select v-model="form.jobId" placeholder="请选择" :disabled="pageType === 'detail'">
                <el-option v-for="item in jobTypeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上级 :" prop="leaderId">
              <el-select v-model="form.leaderId" filterable placeholder="请选择" :disabled="pageType === 'detail'">
                <el-option v-for="item in userArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24">
          <el-form-item label="参加工作日期 :" prop="joinedDate">
            <el-date-picker v-model="form.joinedDate" type="month" value-format="yyyy-MM-01" placeholder="请选择"
              :disabled="pageType === 'detail'"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="账号权限 :" prop="roles">
            <el-checkbox-group v-model="form.roles" :disabled="pageType === 'detail'">
              <el-checkbox :label="item.id" name="roles" v-for="(item, index) in rolesList"
                :key="index">{{ item.name }}</el-checkbox>
              <!-- <el-checkbox label="1" name="roles">藏品保管员</el-checkbox>
              <el-checkbox label="3" name="roles">藏品保管员</el-checkbox>-->
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <!-- 添加员工、编辑员工 end -->

    <!-- 编辑部门信息 start -->
    <div v-if="bussinessType === 'department'">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="100px" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="'部门名称 :'" prop="departmentName">
              <el-input v-model="form.departmentName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上级部门 :" prop="parentId">
              <el-select v-model="form.parentId" placeholder="请选择">
                <el-option v-for="item in departmentArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-for="(item, index) in roleDepartArr" :key="index">
            <!-- <el-form-item :label="item.label+' :'" :prop="form[item.name]"> -->
            <el-form-item :label="item.label + ' :'">
              <el-select multiple filterable clearable v-model="form[item.name]" placeholder="请选择">
                <el-option v-for="item in userArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 编辑部门信息 end -->

    <div slot="footer" class="footer mt-30">
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validate } from '@/utils/util'
export default {
  props: {
    // staff:员工 department:部门
    bussinessType: {
      type: String,
      default: ''
    },
    staffType: {
      type: String,
      default: ''
    },
  },
  data() {
    let validatePhoneNo = (rule, value, callback) => {
      if (!validate(value, 'phone')) {
        callback(new Error('手机号不存在'))
      } else {
        callback()
      }
    }
    let validatePass = (rule, value, callback) => {
      if (!validate(value, 'password')) {
        callback(new Error('6-20位数字、字母、特殊字符至少包含两种'))
      } else {
        callback()
      }
    }
    return {
      loadingSave: false,
      pageType: '', // 页面类型 add 新增  edit 编辑
      detailId: '', // 详情id
      title: '',
      titleHead: '',
      dialogVisible: false,
      rolesList: [],
      partJob: [],

      form: {
        roles: []
      },
      partyJobArr: [{ id: 1, label: '党员' }, { id: 2, label: '支部书记' }, { id: 3, label: '组织委员' }, { id: 4, label: '宣传委员' }, { id: 5, label: '纪检委员' }],
      rules: {
        userName: [{ required: true, message: '必填', trigger: 'blur' }],
        phone: [
          { required: true, message: '必填', trigger: 'blur' },
          { validator: validatePhoneNo, trigger: 'blur' }
        ],
        passwd: [
          { required: true, message: '必填', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        deptId: [{ required: true, message: '必填', trigger: 'blur' }],
        // partyDept: [{ required: true, message: '必填', trigger: 'blur' }],

        // roles: [
        //   {
        //     type: 'array',
        //     required: true,
        //     message: '请至少选择一个账号权限',
        //     trigger: 'change'
        //   }
        // ]
      },
      staffTypeArr: [], // 人员类型；列表
      departmentArr: [], // 部门列表
      partyDeptArr: [], //党支部列表
      jobTypeArr: [], // 职位列表
      userArr: [], // 人员列表
      titleMap: '',

      roleDepartArr: [] // 部门角色列表
    }
  },
  methods: {
    init(type, detailId) {
      this.pageType = type // add 新增  edit 编辑 join 加入到审核用户
      this.detailId = detailId || ''
      this.form = { roles: [] }

      if (this.bussinessType === 'staff') {
        if (this.staffType) {
          this.$set(this.form, 'partyDept', this.$parent._data.listQuery.partyDept) // 获取父级页面部门id
        } else {
          this.$set(this.form, 'deptId', this.$parent._data.listQuery.deptId) // 获取父级页面部门id
        }
        // this.form.deptId = this.$parent._data.listQuery.deptId // 获取父级页面部门id
      } else {
        // this.form.deptId = detailId
        this.$set(this.form, 'deptId', detailId)
      }

      this.$nextTick(() => {
        // this.$refs['form'].resetFields()
        this.$refs['form'].clearValidate()
        if (this.pageType === 'add' && this.bussinessType === 'staff') {
          this.titleMap = '添加在职员工'
        } else if (this.pageType === 'edit' && this.bussinessType === 'staff') {
          this.titleMap = '编辑员工信息'
        } else if (this.pageType === 'join' && this.bussinessType === 'staff') {
          this.titleMap = '加入用户'
        } else if (
          this.pageType === 'edit' &&
          this.bussinessType === 'department'
        ) {
          this.titleMap = '编辑部门信息'
        }
        // if (this.detailId) {
        //   this.getDetail()
        // }
      })

      this.dialogVisible = true
      this.getSelect()
      this.getDeptSelect()
    },
    // 查询下拉框
    getSelect() {
      this.$http.post('/job/employeeDict').then(res => {
        if (res.success) {
          let data = res.result
          this.staffTypeArr = data.employeeType
          this.departmentArr = data.department
          this.jobTypeArr = data.jobType
          this.userArr = data.user
          this.rolesList = data.role

          if (this.detailId) {
            this.getDetail()
          }
        }
      })
    },

    //获取党支部列表
    getDeptSelect() {
      this.$http.post('/deptree/list').then(res => {
        if (res.success) {
          let data = res.result
          this.partyDeptArr = data[1].children
          this.partyDeptArr.unshift({
            id: this.$parent._data.listQuery.partyDept || '',
            label: '辽宁省博物馆党委'
          })
        }
      })
    },
    // 详情
    getDetail() {
      switch (this.bussinessType) {
        case 'staff':
          this.detailStaff()
          break
        case 'department':
          this.detailDepartment()
          break
      }
    },
    // 员工详情
    detailStaff() {
      this.$http
        .get('/user/listEmployee', {
          userId: this.detailId
        })
        .then(res => {
          if (res.success) {
            let data = res.result[0]
            this.form = data

            if (this.form.partJob) {
              this.partJob = this.form.partJob.split(',')
            }
            this.$set(this.form, 'roles', data.roleList)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 部门详情
    detailDepartment() {
      this.$http
        .get('/department/findDept', {
          departmentId: this.detailId
        })
        .then(res => {
          if (res.success) {
            let data = res.result

            this.$set(this.form, 'departmentName', data.departmentName)
            this.$set(this.form, 'parentId', data.parentId)
            this.roleDepartArr = data.deptRole
            data.deptRole.forEach(item => {
              this.$set(this.form, item.name, item.value.split(','))
            })
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 保存
    fromSubmit(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          switch (this.bussinessType) {
            case 'staff':
              this.saveStaff()
              break
            case 'department':
              this.saveDepartment()
              break
          }
        }
      })
    },
    // 保存员工
    saveStaff() {
      this.loadingSave = true
      this.$http
        .post(
          this.pageType === 'add'
            ? '/user/addEmployee'
            : '/user/updateEmployee',
          {
            ...this.form,
            partJob: this.partJob.join(','),
            roleIds: this.form.roles.join(',')
          }
        )
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            if (this.pageType === 'edit' && this.bussinessType === 'staff') {
              this.$message.success('编辑员工信息成功')
            } else if (
              this.pageType === 'join' &&
              this.bussinessType === 'staff'
            ) {
              this.$message.success('加入用户成功')
            } else if (
              this.pageType === 'edit' &&
              this.bussinessType === 'department'
            ) {
              this.$message.success('编辑编辑部门信息成功')
            } else if (this.pageType === 'add') {
              this.$message.success('添加在职员工成功')
            }
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    },
    // 保存部门
    saveDepartment() {
      this.roleDepartArr.forEach(item => {
        this.form[item.name] = this.form[item.name].join(',')
      })

      this.loadingSave = true
      this.$http
        .post('/department/updateDept', {
          ...this.form,
        })
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success('编辑部门信息成功')
            this.dialogVisible = false
            this.$emit('refreshTree')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingSave = false
        })
    },
    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.loadingSave = false
      this.dialogVisible = false
      this.partJob = []
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-add-staff {
  height: 900px;
  overflow: auto;

  /deep/ .el-form-item__error {
    left: 0;
  }
}</style>